import React from 'react';
import { workProcess } from '../data/mockData';
import { ArrowRight } from 'lucide-react';

const HowWeWorkSection = () => {
  return (
    <section id="process" className="relative py-20 bg-gradient-to-b from-gray-900 via-[#1a1a2e] to-gray-900 overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-blue-500 rounded-full opacity-5 blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#FF9900] rounded-full opacity-5 blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Heading */}
        <div className="text-center max-w-4xl mx-auto mb-16">
          <div className="inline-block bg-gradient-to-r from-[#FF9900]/20 to-orange-600/20 border border-[#FF9900]/30 text-[#FF9900] px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Our Process
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Trademark Registration Process | USPTO Filing Steps
          </h2>
          <p className="text-xl text-gray-300 leading-relaxed">
            Our streamlined trademark registration process ensures professional USPTO trademark filing with federal trademark application support. Expert trademark attorneys handle online trademark registration, comprehensive trademark search services, and complete trademark legal services from start to finish.
          </p>
        </div>

        {/* 3 Step Process */}
        <div className="max-w-5xl mx-auto space-y-8">
          {workProcess.map((step, index) => (
            <div key={step.id} className="relative">
              {/* Connector Line */}
              {index !== workProcess.length - 1 && (
                <div className="absolute left-8 top-24 w-1 h-full bg-gradient-to-b from-[#FF9900] to-orange-600 hidden md:block opacity-30"></div>
              )}

              <div className="flex flex-col md:flex-row gap-6 group">
                {/* Step Number */}
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 bg-gradient-to-r from-[#FF9900] to-orange-600 rounded-2xl flex items-center justify-center text-2xl font-bold shadow-lg group-hover:scale-110 transition-transform text-black">
                    {step.step}
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-2xl p-8 group-hover:bg-gray-800/70 group-hover:shadow-2xl group-hover:shadow-[#FF9900]/10 transition-all duration-300 border border-white/10 group-hover:border-[#FF9900]/30">
                  <h3 className="text-2xl font-bold text-white mb-4">{step.title}</h3>
                  <p className="text-gray-300 leading-relaxed text-lg">{step.description}</p>
                </div>

                {/* Arrow */}
                {index !== workProcess.length - 1 && (
                  <div className="hidden lg:flex items-center">
                    <ArrowRight className="w-6 h-6 text-[#FF9900]" />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeWorkSection;